import React, {useContext} from "react";
import {View} from "react-native";

import styles from './screen-styles'
import {styleVars} from "../app-style-vars";
import ScreenTemplate from "./ScreenTemplate";
import PtCustomerInfo from "../components/pt-customer-info/pt-customer-info";
import PtLanguageSelector from "../components/pt-languge-selector/pt-language-selector";
import PtTermsOfUse from "../components/pt-terms-of-use/pt-terms-of-use";
import PtPrivacyPolicy from "../components/pt-privacy-policy/pt-privacy-policy";
import PtImprint from "../components/pt-imprint/pt-imprint";
import PtPrivacySettings from "../components/pt-privacy-policy/pt-privacy-settings";
import Logout from "../components/core/logout/logout";
import {isFeatureAvailable} from "../helpers/isFeatureAvailable";
import PtText from "../components/core/pt-text/pt-text";
import {getTranslation} from "../helpers/getTranslation";
import PtImpersonate from "../components/pt-impersonation/pt-impersonate";
import UserContext from "../helpers/UserContext";

/** set this to styles.withBoundaries to display borders around container views to catch layout overflows */
const showBoundaries = null;
const bottomSeparator = {borderBottomWidth: 1, borderBottomColor: styleVars.boschLightGray};

export default function MyAccountScreen({navigation, route}:any) {

  const legalPagesInfoMessage = getTranslation('legal.pages.info.message') || "Same legal regulations apply as stated in our main B2B portal.";

  const {userData, updateUserData} = useContext(UserContext);

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={{backgroundColor: 'white'}}>

        <View style={[styles.pageContentSlotContainer, showBoundaries, bottomSeparator]}>

          <View style={{borderTopWidth: 1, borderTopColor: styleVars.boschLightGray, paddingVertical: styleVars.rem(0.5)}}>
            <PtLanguageSelector/>
          </View>

          <View style={{borderTopWidth: 1, borderTopColor: styleVars.boschLightGray, paddingVertical: styleVars.rem(0.5)}}>
            <PtCustomerInfo justifyItems={'space-between'} showTitle useToggle showRoles/>
          </View>

          {userData.canImpersonate ?
            <View style={{borderTopWidth: 1, borderTopColor: styleVars.boschLightGray, paddingVertical: styleVars.rem(0.5)}}>
              <PtImpersonate showModal={userData.mustImpersonate && userData.impersonatingId == null}/>
            </View>
            : null
          }

        </View>

        <View style={[styles.pageContentSlotContainer, showBoundaries]}>

          <View style={{paddingHorizontal: 8, paddingVertical: 8, backgroundColor: styleVars.boschInfoBlue}}>
            <PtText>{legalPagesInfoMessage}</PtText>
          </View>

          {isFeatureAvailable('legalPagesTermsOfUse') ?
            <PtTermsOfUse navigation={navigation} route={route}/>
            : null
          }
          {isFeatureAvailable('legalPagesPrivacyPolicy') ?
            <PtPrivacyPolicy navigation={navigation} route={route}/>
            : null
          }
          {isFeatureAvailable('legalPagesImprint') ?
            <PtImprint navigation={navigation} route={route}/>
            : null
          }
          {isFeatureAvailable('legalPagesPrivacyPolicy') ?
            <PtPrivacySettings/>
            : null
          }
          <View style={{borderTopColor: styleVars.boschLightGray, borderTopWidth: 1}}></View>
          <Logout/>
        </View>

      </View>

    </ScreenTemplate>
  )
}
